import { z } from 'zod'
import { PurchaseSchema } from './Purchase'
import { UpgradeIds } from '../common/values/upgrades/enums'

const GameStateSchema = z.object({
	money: z.string(),
	purchases: z.array(PurchaseSchema),
	upgrades: z.array(z.nativeEnum(UpgradeIds)).optional(),
	currentPrestigeLevels: z.string().optional(),
	totalDebtAccumulated: z.string().optional(),
	lifetimeAscensions: z.number().optional()
})

type GameState = z.infer<typeof GameStateSchema>

const isGameState = (obj: unknown): obj is GameState =>
	GameStateSchema.safeParse(obj).success

export { type GameState, isGameState, GameStateSchema }
